import React from 'react'
import { useWarehouseModel } from '../warehouseModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useWarehouseModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '仓库名称',
            fieldName: 'name',
            span:4
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: '仓库类型',
        //     fieldName: 'name',
        //     span:4
        // },
    ]
    const searchMoreFields= [
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: '联系电话',
        //     fieldName: 'code',
        //     span:4
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: '用户状态',
        //     fieldName: 'vehicleBrandCode',
        //     options: getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND),
        //     span:4
        // }
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
